import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const price = (props) => (
  <SvgIcon width="21" height="20" viewBox="0 0 21 20" {...props}>
    <path
      d="M19.41 9.41L10.58 0.58C10.21 0.21 9.7 0 9.17 0H2C0.9 0 0 0.9 0 2V9.17C0 9.7 0.21 10.21 0.59 10.58L9.42 19.41C10.2 20.19 11.47 20.19 12.25 19.41L19.42 12.24C20.2 11.46 20.2 10.2 19.41 9.41ZM10.83 18L2 9.17V2H9.17L18 10.83L10.83 18Z"
      fill="#757575"
    />
  </SvgIcon>
);
export default price;



// WEBPACK FOOTER //
// ./src/common/icons/Price/index.tsx